import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { OwlCarousel } from "ngx-owl-carousel";
import { EssentialService } from "../../services/essential.service";

declare const $: any;

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.css"],
})
export class BannerComponent implements OnInit {
  public slides: any;
  public carouselOptions: any;
  public nav: boolean;
  public slideNumber = 2;
  public checkImg = false;
  public site: any;
  public posts: any[] = [];

  @Input() public data: any;
  @Input() public settings: any;
  @ViewChild("owlElement", { static: true }) public owlElement: OwlCarousel;

  constructor(
    private sinitizer: DomSanitizer,
    private essentialsService: EssentialService
  ) {}

  public ngOnInit() {
    this.slides = this.settings.ImagesLink || [];
    this.nav = this.settings.nav ? true : false;

    this.carouselOptions = {
      nav: this.nav,
      slideBy: this.settings.slideby,
      dots: this.settings.dots,
      mouseDrag: this.settings.mouseDrag,
      touchDrag: this.settings.touchDrag,
      autoplay: this.settings.autoPlay,
      autoplayHoverPause: this.settings.autoPlayHoverPause,
      loop: this.settings.loop,
      rtl: this.settings.rtl,
      autoplayTimeout: this.settings.interval,
      autoplaySpeed: this.settings.autoSpeed,
      margin: this.settings.margin,
      navContainer: this.settings.navContainer,
      dotsContainer: this.settings.dotsContainer,
      navText: [
        "<div class='prev-slide'><i class='fas fa-angle-left fa-2x'></i></div>",
        "<div class='next-slide'><i class='fas fa-angle-right fa-2x'></i></div>",
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: +this.settings.itemsPerPage,
        },
        1500: {
          items: +this.settings.itemsPerPage,
        },
      },
    };
    this.site = this.data.moduleService.site;
    if (this.settings.dataFrom === "blog") {
      this.getPosts(this.settings.selectedCategories);
    }
  }

  public ngAfterViewInit() {

    if (this.settings.cover) {
      $(".banner-image img").height($(window).innerHeight());
    }
    
  }
 
  public goToSlide(i) {
    this.owlElement.to(i);
  }

  public navigateToSection(el: string) {
    const elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }

  public getPosts(ids: any) {
    this.essentialsService.getPosts(ids).subscribe((res: any) => {
      this.posts = res.PostsList;
    });
  }

  public getThumbnailUrl(item) {
    if (item.mediaURLs.length) {
      return "/" + item.mediaURLs[0].url;
    } else {
      return "";
    }
  }
  public urlsafe(url) {
    return this.sinitizer.bypassSecurityTrustUrl(url);
  }

  public setPrefixInHref(url) {
    if (url && url.indexOf("/") == 0 && this.data.moduleService.site.HostName) {
      let replaceWith =
        "/" + decodeURIComponent(this.data.moduleService.site.HostName) + "/";
      return url.replace("/", replaceWith);
    }
    return url;
  }
}
